import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataLoaderService, VehicleInfoService } from '../index';
@Component({
  selector: 'configurator',
  templateUrl: './configurator.template.html',
  styleUrls: ['./configurator.component.css']
})

export class ConfiguratorComponent {
  constructor(private translate: TranslateService, private dataLoaderService: DataLoaderService,
  private vehicleInfoService:VehicleInfoService) {
    // this.translate.addLangs(["English", "Deutsche", "한국어", "Español"]);
    // const browserLang = this.translate.getBrowserLang();
    // this.translate.use(browserLang.match(/English|Deutsche|한국어|Español/) ? browserLang : 'English');
  }
  dataAvailable() {
    return (this.dataLoaderService.flagDictionary.dataFlag);
  }
  globalLoading() {
    document.getElementById('globalLoading').style.display = 'none';
    return true;
  }
initialError() {
    if (this.dataLoaderService.flagDictionary.exceptionFlag) {
      //this.dataLoaderService.flagDictionary.alternateOverlayFlag = true;
      document.getElementById("exceptionError").style.display = "block";
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/configurator/configurator.component.ts